var map = {
	"./Activity": [
		90833,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/": [
		90833,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/ActivityList": [
		45664,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/ActivityList/": [
		45664,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/ActivityList/index": [
		45664,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/ActivityList/index.tsx": [
		45664,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/FirstCharge": [
		86419,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/FirstCharge/": [
		86419,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/FirstCharge/index": [
		86419,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/FirstCharge/index.tsx": [
		86419,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/RechargeTypeElement": [
		5321,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/RechargeTypeElement/": [
		5321,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/RechargeTypeElement/index": [
		5321,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/components/RechargeTypeElement/index.tsx": [
		5321,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/index": [
		90833,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./Activity/index.tsx": [
		90833,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails": [
		11220,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/": [
		11220,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/WeeklyJackpot": [
		18830,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/WeeklyJackpot/": [
		18830,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/WeeklyJackpot/index": [
		18830,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/WeeklyJackpot/index.tsx": [
		18830,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/RelatedEvents": [
		72252,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/RelatedEvents/": [
		72252,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/RelatedEvents/index": [
		72252,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/RelatedEvents/index.tsx": [
		72252,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/SupportSection": [
		24790,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/SupportSection/": [
		24790,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/SupportSection/index": [
		24790,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/components/common/SupportSection/index.tsx": [
		24790,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/index": [
		11220,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ActivityDetails/index.tsx": [
		11220,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy": [
		26307,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/": [
		26307,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/CommissionDetails": [
		41811,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/CommissionDetails/": [
		41811,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/CommissionDetails/index": [
		41811,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/CommissionDetails/index.tsx": [
		41811,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/ReferralDetails": [
		87331,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/ReferralDetails/": [
		87331,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/ReferralDetails/index": [
		87331,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Details/ReferralDetails/index.tsx": [
		87331,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Overview": [
		67790,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Overview/": [
		67790,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Overview/index": [
		67790,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/components/Overview/index.tsx": [
		67790,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/index": [
		26307,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AffiliateProxy/index.tsx": [
		26307,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AuditRecords": [
		1951,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AuditRecords/": [
		1951,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AuditRecords/index": [
		1951,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./AuditRecords/index.tsx": [
		1951,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings": [
		31581,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/": [
		31581,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/LoginInformation": [
		56881,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/LoginInformation/": [
		56881,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/LoginInformation/index": [
		56881,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/LoginInformation/index.tsx": [
		56881,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/MailNumber": [
		275,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/MailNumber/": [
		275,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/MailNumber/index": [
		275,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/MailNumber/index.tsx": [
		275,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security": [
		65445,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/": [
		65445,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/Account": [
		60215,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/Account/": [
		60215,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/Account/index": [
		60215,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/Account/index.tsx": [
		60215,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/disable": [
		92396,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/disable/": [
		92396,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/disable/index": [
		92396,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/disable/index.tsx": [
		92396,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/enable": [
		49709,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/enable/": [
		49709,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/enable/index": [
		49709,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/enable/index.tsx": [
		49709,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/index": [
		65445,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/Security/index.tsx": [
		65445,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/index": [
		31581,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GlobalSettings/index.tsx": [
		31581,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GoogleTowFactor": [
		3527,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GoogleTowFactor/": [
		3527,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GoogleTowFactor/index": [
		3527,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./GoogleTowFactor/index.tsx": [
		3527,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./IWDunlock": [
		93162,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./IWDunlock/": [
		93162,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./IWDunlock/index": [
		93162,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./IWDunlock/index.tsx": [
		93162,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard": [
		16255,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/": [
		16255,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Brokerage": [
		75779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Brokerage/": [
		75779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Brokerage/index": [
		75779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Brokerage/index.tsx": [
		75779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Codes": [
		22971,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Codes/": [
		22971,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Codes/index": [
		22971,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Codes/index.tsx": [
		22971,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Friend": [
		75059,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Friend/": [
		75059,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Friend/index": [
		75059,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Friend/index.tsx": [
		75059,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Invites": [
		27761,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Invites/": [
		27761,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Invites/index": [
		27761,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/components/Invites/index.tsx": [
		27761,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/index": [
		16255,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./InviteDashBoard/index.tsx": [
		16255,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./NationalProxy": [
		31940,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./NationalProxy/": [
		31940,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./NationalProxy/index": [
		31940,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./NationalProxy/index.tsx": [
		31940,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./PrivacyPage": [
		53364,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./PrivacyPage/": [
		53364,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./PrivacyPage/index": [
		53364,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./PrivacyPage/index.tsx": [
		53364,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./TaskCenter": [
		25486,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./TaskCenter/": [
		25486,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./TaskCenter/index": [
		25486,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./TaskCenter/index.tsx": [
		25486,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bettingRebate": [
		9342,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bettingRebate/": [
		9342,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bettingRebate/index": [
		9342,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bettingRebate/index.tsx": [
		9342,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bingo": [
		9183,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bingo/": [
		9183,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bingo/index": [
		9183,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bingo/index.tsx": [
		9183,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus": [
		38523,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/": [
		38523,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/AwardItem": [
		62069,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/AwardItem/": [
		62069,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/AwardItem/index": [
		62069,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/AwardItem/index.tsx": [
		62069,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/FarmItem": [
		53752,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/FarmItem/": [
		53752,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/FarmItem/index": [
		53752,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/FarmItem/index.tsx": [
		53752,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LevelMask": [
		41121,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LevelMask/": [
		41121,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LevelMask/index": [
		41121,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LevelMask/index.tsx": [
		41121,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LuckyItem": [
		32998,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LuckyItem/": [
		32998,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LuckyItem/index": [
		32998,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/LuckyItem/index.tsx": [
		32998,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/MonthItem": [
		53404,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/MonthItem/": [
		53404,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/MonthItem/index": [
		53404,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/MonthItem/index.tsx": [
		53404,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/TaskItem": [
		71941,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/TaskItem/": [
		71941,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/TaskItem/index": [
		71941,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/TaskItem/index.tsx": [
		71941,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/WeekItem": [
		64596,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/WeekItem/": [
		64596,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/WeekItem/index": [
		64596,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/WeekItem/index.tsx": [
		64596,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/boxItem": [
		94553,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/boxItem/": [
		94553,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/boxItem/index": [
		94553,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/components/boxItem/index.tsx": [
		94553,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/index": [
		38523,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./bonus/index.tsx": [
		38523,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./farmElement": [
		54882,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./farmElement/": [
		54882,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./farmElement/index": [
		54882,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./farmElement/index.tsx": [
		54882,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./favoriteList": [
		95650,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./favoriteList/": [
		95650,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./favoriteList/index": [
		95650,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./favoriteList/index.tsx": [
		95650,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./fishing": [
		90288,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./fishing/": [
		90288,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./fishing/index": [
		90288,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./fishing/index.tsx": [
		90288,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./funList": [
		86033,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./funList/": [
		86033,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./funList/index": [
		86033,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./funList/index.tsx": [
		86033,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game": [
		65367,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/": [
		65367,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/currencySelect": [
		85057,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/currencySelect/": [
		85057,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/currencySelect/index": [
		85057,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/currencySelect/index.tsx": [
		85057,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/moveTag": [
		76967,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/moveTag/": [
		76967,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/moveTag/index": [
		76967,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/components/moveTag/index.tsx": [
		76967,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/index": [
		65367,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./game/index.tsx": [
		65367,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hacksawList": [
		79468,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hacksawList/": [
		79468,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hacksawList/index": [
		79468,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hacksawList/index.tsx": [
		79468,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement": [
		50870,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/": [
		50870,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/BettingRecords": [
		78740,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/BettingRecords/": [
		78740,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/BettingRecords/index": [
		78740,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/BettingRecords/index.tsx": [
		78740,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/LedgerRecords": [
		9088,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/LedgerRecords/": [
		9088,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/LedgerRecords/index": [
		9088,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/LedgerRecords/index.tsx": [
		9088,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/RechargeRecords": [
		41960,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/RechargeRecords/": [
		41960,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/RechargeRecords/index": [
		41960,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/RechargeRecords/index.tsx": [
		41960,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/WithdrawalRecords": [
		78294,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/WithdrawalRecords/": [
		78294,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/WithdrawalRecords/index": [
		78294,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/WithdrawalRecords/index.tsx": [
		78294,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/index": [
		50870,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./historyElement/index.tsx": [
		50870,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home": [
		85023,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/": [
		85023,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/components/bannerUI": [
		92359,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/components/bannerUI/": [
		92359,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/components/bannerUI/index": [
		92359,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/components/bannerUI/index.tsx": [
		92359,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/index": [
		85023,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./home/index.tsx": [
		85023,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hotList": [
		83923,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hotList/": [
		83923,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hotList/index": [
		83923,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./hotList/index.tsx": [
		83923,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./howToPlay": [
		80237,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./howToPlay/": [
		80237,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./howToPlay/index": [
		80237,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./howToPlay/index.tsx": [
		80237,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./interestingList": [
		52116,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./interestingList/": [
		52116,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./interestingList/index": [
		52116,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./interestingList/index.tsx": [
		52116,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jdbList": [
		25002,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jdbList/": [
		25002,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jdbList/index": [
		25002,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jdbList/index.tsx": [
		25002,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jiliList": [
		62628,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jiliList/": [
		62628,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jiliList/index": [
		62628,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./jiliList/index.tsx": [
		62628,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./miniGameList": [
		80765,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./miniGameList/": [
		80765,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./miniGameList/index": [
		80765,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./miniGameList/index.tsx": [
		80765,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./pgList": [
		19309,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./pgList/": [
		19309,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./pgList/index": [
		19309,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./pgList/index.tsx": [
		19309,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./platformList": [
		6779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./platformList/": [
		6779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./platformList/index": [
		6779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./platformList/index.tsx": [
		6779,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./playedList": [
		53496,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./playedList/": [
		53496,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./playedList/index": [
		53496,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./playedList/index.tsx": [
		53496,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ppList": [
		57262,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ppList/": [
		57262,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ppList/index": [
		57262,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./ppList/index.tsx": [
		57262,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./privacyPolicy": [
		35263,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./privacyPolicy/": [
		35263,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./privacyPolicy/index": [
		35263,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./privacyPolicy/index.tsx": [
		35263,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeRewards": [
		61012,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeRewards/": [
		61012,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeRewards/index": [
		61012,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeRewards/index.tsx": [
		61012,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeSpinActivity": [
		46064,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeSpinActivity/": [
		46064,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeSpinActivity/index": [
		46064,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./rechargeSpinActivity/index.tsx": [
		46064,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./recommendList": [
		37840,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./recommendList/": [
		37840,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./recommendList/index": [
		37840,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./recommendList/index.tsx": [
		37840,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./responsibleGaming": [
		87369,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./responsibleGaming/": [
		87369,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./responsibleGaming/index": [
		87369,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./responsibleGaming/index.tsx": [
		87369,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./share": [
		8387,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./share/": [
		8387,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./share/index": [
		8387,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./share/index.tsx": [
		8387,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./slotList": [
		5570,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./slotList/": [
		5570,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./slotList/index": [
		5570,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./slotList/index.tsx": [
		5570,
		3928,
		7956,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsIm": [
		19053,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsIm/": [
		19053,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsIm/index": [
		19053,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsIm/index.tsx": [
		19053,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsPb": [
		72293,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsPb/": [
		72293,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsPb/index": [
		72293,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./sportsPb/index.tsx": [
		72293,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./tableList": [
		25642,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./tableList/": [
		25642,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./tableList/index": [
		25642,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./tableList/index.tsx": [
		25642,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./termsOfService": [
		49217,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./termsOfService/": [
		49217,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./termsOfService/index": [
		49217,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	],
	"./termsOfService/index.tsx": [
		49217,
		428,
		1802,
		2700,
		2545,
		110,
		8941
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6777;
module.exports = webpackAsyncContext;